/**
 * Sudo Banner Component
 * Displays when admin is in sudo mode, with option to exit
 */

import { AlertTriangle, X } from 'lucide-react';
import { useSudoSession } from '@/hooks/useSudoSession';
import { useAuthState } from '@/auth/AuthProvider';

export default function SudoBanner() {
  const { user } = useAuthState();
  const { sudoState, endSudo, isSudoActive } = useSudoSession(user?.uid || null);

  if (!isSudoActive() || !sudoState) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 border-b-2 border-red-500 bg-red-600 px-4 py-2">
      <div className="mx-auto flex max-w-7xl items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-5 w-5 text-white" />
          <div className="text-white">
            <span className="font-bold">SUDO MODE ACTIVE</span>
            <span className="ml-2 text-sm opacity-90">
              Viewing as: {sudoState.targetUserId.slice(0, 12)}...
            </span>
          </div>
        </div>
        <button
          onClick={async () => {
            await endSudo();
            window.location.href = '/admin';
          }}
          className="flex items-center gap-2 rounded bg-slate-800 px-3 py-1 text-sm font-semibold text-red-400 transition-all hover:bg-slate-700"
        >
          <X className="h-4 w-4" />
          Exit Sudo
        </button>
      </div>
    </div>
  );
}
